import { includes } from 'lodash';

import { GC_ROLES, ROLE_PRIORITY } from './constants';

export const getDefaultRole = (heldRoles) => ROLE_PRIORITY.find((role) => includes(heldRoles, role)) || null;

// The held role (Admins outranks GuestPermit) that admits /gc guest-checkpoint desk calls, or
// null if none is held — see constants.GC_ROLES and mixedAuthLubaApi.js, which sends this as
// X-Active-Role instead of the switchable active role the rest of the app uses.
export const getGcRole = (heldRoles) => GC_ROLES.find((role) => includes(heldRoles, role)) || null;

// Mirrors backend GetEffectiveRole: a stored role that is not held falls back to the default.
export const resolveActiveRole = (storedRole, heldRoles) => {
  if (storedRole && includes(ROLE_PRIORITY, storedRole) && includes(heldRoles, storedRole)) {
    return storedRole;
  }
  return getDefaultRole(heldRoles);
};
